import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import Banner from 'components/Banner';
import React from 'react';
import AdditionalPageContent from './PageContent';

const AdditionalPage = ({ title, background, buttonText, pageContentData }) => {
    return (
        <>
            <Banner title={title} image={background} buttonText={buttonText} />
            <AdditionalPageContent pageContentData={pageContentData} />
        </>
    );
};

export default AdditionalPage;
